import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { logout, logoutUser } from "../../redux/authSlice";
import Images from "../../assests/imgs/Imges";
import { buildPermissionContext } from "../../util/permissions";
import { fetchActionItemsCountInfo } from "../../redux/taskSlice";
import { useEffect } from "react";
import ActionItem from "./ActionItem";

const CounterBadges = ({ redCount, blueCount }) => (
  <div style={{
    position: "absolute",
    bottom: "-6px",
    right: "-2px",
    display: "flex",
    flexDirection: "column",
    gap: "1px",
  }}>
    <span style={{
      background: "red",
      color: "#fff",
      borderRadius: "8px",
      padding: "2px 2px",
      fontSize: "0.6em",
      fontWeight: 700,
      lineHeight: "1.4",
      minWidth: "10px",
      textAlign: "center",
    }}>{redCount}</span>
    <span style={{
      background: "#0D6EFD",
      color: "#fff",
      borderRadius: "8px",
      padding: "2px 2px",
      fontSize: "0.6em",
      fontWeight: 700,
      lineHeight: "1.4",
      minWidth: "10px",
      textAlign: "center",
    }}>{blueCount}</span>
  </div>
);

const ProfileDropdown = ({
  showProfileDropdown,
  setShowProfileDropdown,
  profileRef,
  showProfileButton,
  counterBadges = null,
  /** Live Directory only: minimal menu (signed in, storage, action items, logout) — does not affect classic AppBar */
  compactLiveDirectory = false,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const user = useSelector((state) => state.auth.user);
  const authUser = useSelector((state) => state.auth.user);
  const { count_info } = useSelector((state) => state.task);
  const permissionCtx = buildPermissionContext(authUser);
  const isAdmin = permissionCtx.permissions?.Admin === true;
  const showProfileImage = true;

  // const redCount = parseInt(count_info?.due_count || 0) + parseInt(count_info?.overdue_count || 0);
  // const blueCount = parseInt(count_info?.reassigned_count || 0) + parseInt(count_info?.rev_count || 0);

  // useEffect(() => {
  //   if (isAdmin) {
  //     dispatch(fetchActionItemsCountInfo({}));
  //   }
  // }, [isAdmin, dispatch]);

  const userLogout = async () => {
    sessionStorage.removeItem("redirectAfterLogin");
    localStorage.removeItem("userAttentionPopupShown");
    try {
      await dispatch(logoutUser());
    } catch (error) {
      // Even if logout API fails, we still want to clear local data and redirect
      console.error("Logout error:", error);
    } finally {
      // Ensure we redirect to login after logout
      navigate("/login", { replace: true });
    }
  };

  const displayUserName =
    [user?.first_name, user?.last_name].filter(Boolean).join(" ").trim() ||
    (typeof localStorage !== "undefined" ? localStorage.getItem("user_name") : "") ||
    "";

  return (
    <div className="profile-menu" ref={profileRef}>
      {showProfileButton && (
        <>
          <button
            className="profile-icon"
            style={{ marginTop: "2px" }}
            onClick={() => setShowProfileDropdown(!showProfileDropdown)}
          >
            <div style={{ position: "relative", width: "39px", height: "39px", flexShrink: 0 }}>
              {showProfileImage ? (
                <img
                  src={Images.Profile}
                  alt="Profile"
                  className="profile-image"
                  onError={(e) => {
                    e.target.style.display = "none";
                  }}
                />
              ) : (
                <div className="profile-initials">
                  {user?.first_name?.[0]}
                  {user?.last_name?.[0]}
                </div>
              )}
              {counterBadges && !compactLiveDirectory && (
                <CounterBadges
                  redCount={counterBadges.red}
                  blueCount={counterBadges.blue}
                />
              )}
            </div>
            <svg
              width="7"
              height="7"
              viewBox="0 0 10 6"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              style={{
                transition: "transform 0.2s ease",
                transform: showProfileDropdown ? "rotate(180deg)" : "rotate(0deg)",
                flexShrink: 0,
              }}
            >
              <path
                d="M1 1L5 5L9 1"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </>
      )}
      {showProfileDropdown && (
        <div
          className="dropdown-menu-profile"
          style={{ width: compactLiveDirectory ? "220px" : "200px" }}
        >
          {isAuthenticated ? (
            compactLiveDirectory ? (
              <>
                <div className="profile-info">
                  <div className="signed-in-as">Signed in as</div>
                  <div className="profile-name" style={{ fontWeight: 700 }}>
                    {displayUserName}
                  </div>
                </div>
                <div className="dropdown-divider"></div>
                <div className="dropdown-section">
                  <span
                    className="dropdown-item"
                    style={{
                      fontSize: "12px",
                      fontWeight: 700,
                      color: "#333",
                      cursor: "default",
                    }}
                  >
                    Offline Storage: 500 MB MAX
                  </span>
                </div>
                <div className="dropdown-divider"></div>
                <div className="dropdown-section">
                  <Link
                    to="/actionitems"
                    className="dropdown-item"
                    onClick={() => setShowProfileDropdown(false)}
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      boxSizing: "border-box",
                      gap: "8px",
                    }}
                  >
                    <span>Action Items</span>
                    {/* <ActionItemsRowBadges
                      redCount={counterBadges?.red ?? 0}
                      blueCount={counterBadges?.blue ?? 0}
                    /> */}
                  </Link>
                </div>
                <div className="dropdown-divider"></div>
                <button
                  type="button"
                  className="dropdown-item"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    width: "100%",
                    paddingRight: "6px",
                    boxSizing: "border-box",
                    border: "none",
                    background: "transparent",
                    cursor: "pointer",
                    textAlign: "left",
                  }}
                  onClick={userLogout}
                >
                  Logout
                  <span
                    style={{
                      marginLeft: "auto",
                      width: "13px",
                      height: "13px",
                      flexShrink: 0,
                    }}
                  >
                    <svg
                      width="13"
                      height="13"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1.70141 16C1.22596 16 0.823529 15.8353 0.494118 15.5059C0.164706 15.1765 0 14.774 0 14.2986V1.70141C0 1.22596 0.164706 0.823529 0.494118 0.494118C0.823529 0.164706 1.22596 0 1.70141 0H8.00894V1.41176H1.70141C1.62894 1.41176 1.56259 1.44196 1.50235 1.50235C1.44196 1.56259 1.41176 1.62894 1.41176 1.70141V14.2986C1.41176 14.3711 1.44196 14.4374 1.50235 14.4976C1.56259 14.558 1.62894 14.5882 1.70141 14.5882H8.00894V16H1.70141ZM11.9819 12.0181L11.0045 10.9972L13.296 8.70588H5.26706V7.29412H13.296L11.0045 5.00282L11.9819 3.98188L16 8L11.9819 12.0181Z"
                        fill="#DC3545"
                      />
                    </svg>
                  </span>
                </button>
              </>
            ) : (
            <>
              <div className="profile-info">
                <div className="signed-in-as">Signed in as</div>
                <div className="profile-name">
                  {localStorage.user_name}
                  <div>v1.3.2</div>
                </div>
              </div>
              <div className="dropdown-divider"></div>
              <div className="dropdown-section">
                <span
                  className="dropdown-item"
                  style={{
                    fontSize: "11px",
                    opacity: 0.6,
                    cursor: "not-allowed",
                  }}
                >
                  Offline Storage : 500 MB MAX
                </span>
                {/* <Link
                  to="/types"
                  className="dropdown-item"
                  style={{ fontSize: "11px" }}
                >
                  Offline Storage : 500 MB MAX
                </Link> */}
              </div>
              <div className="dropdown-divider"></div>
              {isAdmin ? (
                // Admin Dropdown Menu
                <>
                  <ActionItem />
                  <div className="dropdown-divider"></div>

                  <div className="dropdown-section">
                    <Link
                      to="/units"
                      className="dropdown-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "6px",
                        boxSizing: "border-box",
                      }}
                    >
                      Unit Types
                      <span
                        style={{
                          marginLeft: "auto",
                          marginRight: "0",
                          width: "13px",
                          height: "13px",
                          flexShrink: 0,
                        }}
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 15 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M5.625 1.4375V4.25H0.9375V1.4375H5.625ZM0.9375 0.5C0.68886 0.5 0.450403 0.598772 0.274587 0.774587C0.0987721 0.950403 0 1.18886 0 1.4375L0 4.25C0 4.49864 0.0987721 4.7371 0.274587 4.91291C0.450403 5.08873 0.68886 5.1875 0.9375 5.1875H5.625C5.87364 5.1875 6.1121 5.08873 6.28791 4.91291C6.46373 4.7371 6.5625 4.49864 6.5625 4.25V1.4375C6.5625 1.18886 6.46373 0.950403 6.28791 0.774587C6.1121 0.598772 5.87364 0.5 5.625 0.5H0.9375ZM14.0625 11.75V14.5625H9.375V11.75H14.0625ZM9.375 10.8125C9.12636 10.8125 8.8879 10.9113 8.71209 11.0871C8.53627 11.2629 8.4375 11.5014 8.4375 11.75V14.5625C8.4375 14.8111 8.53627 15.0496 8.71209 15.2254C8.8879 15.4012 9.12636 15.5 9.375 15.5H14.0625C14.3111 15.5 14.5496 15.4012 14.7254 15.2254C14.9012 15.0496 15 14.8111 15 14.5625V11.75C15 11.5014 14.9012 11.2629 14.7254 11.0871C14.5496 10.9113 14.3111 10.8125 14.0625 10.8125H9.375ZM5.625 8V14.5625H0.9375V8H5.625ZM0.9375 7.0625C0.68886 7.0625 0.450403 7.16127 0.274587 7.33709C0.0987721 7.5129 0 7.75136 0 8L0 14.5625C0 14.8111 0.0987721 15.0496 0.274587 15.2254C0.450403 15.4012 0.68886 15.5 0.9375 15.5H5.625C5.87364 15.5 6.1121 15.4012 6.28791 15.2254C6.46373 15.0496 6.5625 14.8111 6.5625 14.5625V8C6.5625 7.75136 6.46373 7.5129 6.28791 7.33709C6.1121 7.16127 5.87364 7.0625 5.625 7.0625H0.9375ZM14.0625 1.4375V8H9.375V1.4375H14.0625ZM9.375 0.5C9.12636 0.5 8.8879 0.598772 8.71209 0.774587C8.53627 0.950403 8.4375 1.18886 8.4375 1.4375V8C8.4375 8.24864 8.53627 8.4871 8.71209 8.66291C8.8879 8.83873 9.12636 8.9375 9.375 8.9375H14.0625C14.3111 8.9375 14.5496 8.83873 14.7254 8.66291C14.9012 8.4871 15 8.24864 15 8V1.4375C15 1.18886 14.9012 0.950403 14.7254 0.774587C14.5496 0.598772 14.3111 0.5 14.0625 0.5H9.375Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </Link>
                    <Link
                      to="/suggestionRules"
                      className="dropdown-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "6px",
                        boxSizing: "border-box",
                      }}
                    >
                      Suggestion Rules
                      <span
                        style={{
                          marginLeft: "auto",
                          marginRight: "0",
                          width: "13px",
                          height: "13px",
                          flexShrink: 0,
                        }}
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.9635 15.9943L9.83075 13.8615L10.5193 13.173L11.9443 14.598L15.2923 11.25L16 11.9578L11.9635 15.9943ZM0 16V15H8V16H0ZM0 12.25V11.25H8V12.25H0ZM0 8.5V7.5H16V8.5H0ZM0 4.75V3.75H16V4.75H0ZM0 1V0H16V1H0Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </Link>
                    <Link
                      to="/procedure-template-rules"
                      className="dropdown-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "6px",
                        boxSizing: "border-box",
                      }}
                    >
                      <span>
                        New Document
                        <br />
                        Template Rules
                      </span>
                      <span
                        style={{
                          marginLeft: "auto",
                          marginRight: "0",
                          width: "15px",
                          height: "15px",
                          flexShrink: 0,
                        }}
                      >
                        <svg
                          width="15"
                          height="15"
                          viewBox="0 0 14 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.0004 16.8948V5.97818L8.82936 0.807129H2.50918C1.89965 0.807129 1.31508 1.04926 0.884078 1.48027C0.453073 1.91127 0.210938 2.49584 0.210938 3.10537V16.8948C0.210938 17.5044 0.453073 18.0889 0.884078 18.52C1.31508 18.951 1.89965 19.1931 2.50918 19.1931H11.7022C12.3117 19.1931 12.8963 18.951 13.3273 18.52C13.7583 18.0889 14.0004 17.5044 14.0004 16.8948ZM8.82936 4.2545C8.82936 4.71165 9.01096 5.15007 9.33422 5.47333C9.65747 5.79658 10.0959 5.97818 10.553 5.97818H12.8513V11.1492H1.36006V3.10537C1.36006 2.80061 1.48113 2.50832 1.69663 2.29282C1.91213 2.07732 2.20442 1.95625 2.50918 1.95625H8.82936V4.2545ZM1.36006 14.5966V12.2984H3.65831V14.5966H1.36006ZM1.36006 15.7457H3.65831V18.044H2.50918C2.20442 18.044 1.91213 17.9229 1.69663 17.7074C1.48113 17.4919 1.36006 17.1996 1.36006 16.8948V15.7457ZM4.80743 18.044V15.7457H12.8513V16.8948C12.8513 17.1996 12.7302 17.4919 12.5147 17.7074C12.2992 17.9229 12.0069 18.044 11.7022 18.044H4.80743ZM12.8513 14.5966H4.80743V12.2984H12.8513V14.5966Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </Link>
                    <span
                      className="dropdown-item"
                      style={{
                        cursor: "not-allowed",
                        opacity: 0.6,
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "6px",
                        boxSizing: "border-box",
                      }}
                      onClick={(e) => e.preventDefault()}
                    >
                      Form Templates
                      <span
                        style={{
                          marginLeft: "auto",
                          marginRight: "0",
                          width: "12px",
                          height: "12px",
                          flexShrink: 0,
                        }}
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0L14 0C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2ZM15 4H11V7H15V4ZM15 8H11V11H15V8ZM15 12H11V15H14C14.2652 15 14.5196 14.8946 14.7071 14.7071C14.8946 14.5196 15 14.2652 15 14V12ZM10 15V12H6V15H10ZM5 15V12H1V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H5ZM1 11H5V8H1V11ZM1 7H5V4H1V7ZM6 4V7H10V4H6ZM10 8H6V11H10V8Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </span>

                    <Link
                      to="/canvas-templates"
                      className="dropdown-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "6px",
                        boxSizing: "border-box",
                      }}
                    >
                      Canvas Page Templates
                      <span
                        style={{
                          marginLeft: "auto",
                          marginRight: "0",
                          width: "12px",
                          height: "12px",
                          flexShrink: 0,
                        }}
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 16 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0L14 0C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14V2ZM15 4H11V7H15V4ZM15 8H11V11H15V8ZM15 12H11V15H14C14.2652 15 14.5196 14.8946 14.7071 14.7071C14.8946 14.5196 15 14.2652 15 14V12ZM10 15V12H6V15H10ZM5 15V12H1V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H5ZM1 11H5V8H1V11ZM1 7H5V4H1V7ZM6 4V7H10V4H6ZM10 8H6V11H10V8Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </Link>
                  </div>
                  <div className="dropdown-divider"></div>

                  <div className="dropdown-section">
                    <Link
                      className="dropdown-item"
                      to="/users"
                      style={{
                        opacity: isAdmin ? 1 : 0.5,
                        pointerEvents: isAdmin ? "auto" : "none",
                        cursor: isAdmin ? "pointer" : "not-allowed",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "6px",
                        boxSizing: "border-box",
                      }}
                      onClick={(e) => {
                        if (!isAdmin) e.preventDefault();
                      }}
                    >
                      Users
                      <span
                        style={{
                          marginLeft: "auto",
                          marginRight: "0",
                          width: "13px",
                          height: "13px",
                          flexShrink: 0,
                        }}
                      >
                        <svg
                          width="13"
                          height="13"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7 6.38428C6.175 6.38428 5.46875 6.09053 4.88125 5.50303C4.29375 4.91553 4 4.20928 4 3.38428C4 2.55928 4.29375 1.85303 4.88125 1.26553C5.46875 0.678027 6.175 0.384277 7 0.384277C7.825 0.384277 8.53125 0.678027 9.11875 1.26553C9.70625 1.85303 10 2.55928 10 3.38428C10 4.20928 9.70625 4.91553 9.11875 5.50303C8.53125 6.09053 7.825 6.38428 7 6.38428ZM0 13.6153V11.969C0 11.5562 0.120167 11.1699 0.3605 10.8103C0.601 10.4508 0.924417 10.1716 1.33075 9.97278C2.27442 9.52028 3.21867 9.18086 4.1635 8.95453C5.10833 8.72836 6.05383 8.61528 7 8.61528C7.94617 8.61528 8.89167 8.72836 9.8365 8.95453C10.7813 9.18086 11.7256 9.52028 12.6693 9.97278C13.0756 10.1716 13.399 10.4508 13.6395 10.8103C13.8798 11.1699 14 11.5562 14 11.969V13.6153H0ZM1 12.6153H13V11.969C13 11.7472 12.9285 11.5389 12.7855 11.344C12.6427 11.1492 12.4449 10.9844 12.1923 10.8498C11.3693 10.4511 10.5207 10.1457 9.6465 9.93353C8.77233 9.72136 7.89017 9.61528 7 9.61528C6.10983 9.61528 5.22767 9.72136 4.3535 9.93353C3.47933 10.1457 2.63075 10.4511 1.80775 10.8498C1.55508 10.9844 1.35733 11.1492 1.2145 11.344C1.0715 11.5389 1 11.7472 1 11.969V12.6153ZM7 5.38428C7.55 5.38428 8.02083 5.18844 8.4125 4.79678C8.80417 4.40511 9 3.93428 9 3.38428C9 2.83428 8.80417 2.36344 8.4125 1.97178C8.02083 1.58011 7.55 1.38428 7 1.38428C6.45 1.38428 5.97917 1.58011 5.5875 1.97178C5.19583 2.36344 5 2.83428 5 3.38428C5 3.93428 5.19583 4.40511 5.5875 4.79678C5.97917 5.18844 6.45 5.38428 7 5.38428Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </Link>
                    <Link
                      to="/audit-trail"
                      className="dropdown-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "6px",
                        boxSizing: "border-box",
                      }}
                    >
                      <span style={{ marginTop: "-5px" }}>Audit Trail</span>
                      <span
                        style={{
                          marginLeft: "auto",
                          marginRight: "0",
                          width: "14px",
                          height: "14px",
                          flexShrink: 0,
                        }}
                      >
                        <svg
                          width="19"
                          height="20"
                          viewBox="0 0 19 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M8.11523 7.79834C8.53707 7.79834 8.89248 7.65376 9.18148 7.36459C9.47065 7.07559 9.61523 6.72017 9.61523 6.29834C9.61523 5.87651 9.47065 5.52109 9.18148 5.23209C8.89248 4.94292 8.53707 4.79834 8.11523 4.79834C7.6934 4.79834 7.33798 4.94292 7.04898 5.23209C6.75982 5.52109 6.61523 5.87651 6.61523 6.29834C6.61523 6.72017 6.75982 7.07559 7.04898 7.36459C7.33798 7.65376 7.6934 7.79834 8.11523 7.79834ZM8.13448 11.7983C8.69215 11.7983 9.22965 11.6945 9.74698 11.4868C10.2643 11.2792 10.7326 10.9798 11.1517 10.5888C10.6326 10.3208 10.1194 10.1221 9.61224 9.99259C9.10524 9.86309 8.61265 9.79834 8.13448 9.79834C7.54082 9.79834 6.97448 9.86626 6.43548 10.0021C5.89632 10.1381 5.45048 10.3337 5.09798 10.5888C5.50432 10.9798 5.9694 11.2792 6.49323 11.4868C7.0169 11.6945 7.56398 11.7983 8.13448 11.7983ZM18.2922 19.2021L13.0345 13.9446C12.2998 14.5419 11.5424 15.0003 10.7622 15.3196C9.98223 15.6388 9.0999 15.7983 8.11523 15.7983C6.0229 15.7983 4.24982 15.0714 2.79598 13.6176C1.34215 12.1638 0.615234 10.3907 0.615234 8.29834C0.615234 6.20601 1.34215 4.43292 2.79598 2.97909C4.24982 1.52526 6.0229 0.79834 8.11523 0.79834C10.2076 0.79834 11.9807 1.52526 13.4345 2.97909C14.8883 4.43292 15.6152 6.20601 15.6152 8.29834C15.6152 9.28301 15.4557 10.1686 15.1365 10.9551C14.8172 11.7416 14.3588 12.5022 13.7615 13.2368L18.9997 18.4753L18.2922 19.2021ZM8.11523 14.7983C9.91007 14.7983 11.4422 14.1638 12.7115 12.8946C13.9807 11.6253 14.6152 10.0932 14.6152 8.29834C14.6152 6.50351 13.9807 4.97142 12.7115 3.70209C11.4422 2.43292 9.91007 1.79834 8.11523 1.79834C6.3204 1.79834 4.78832 2.43292 3.51898 3.70209C2.24982 4.97142 1.61523 6.50351 1.61523 8.29834C1.61523 10.0932 2.24982 11.6253 3.51898 12.8946C4.78832 14.1638 6.3204 14.7983 8.11523 14.7983Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </Link>
                    <Link
                      to="/backups"
                      className="dropdown-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "6px",
                        boxSizing: "border-box",
                      }}
                    >
                      <span style={{ marginTop: "-5px" }}>Backups</span>
                      <span
                        style={{
                          marginLeft: "auto",
                          marginRight: "0",
                          width: "14px",
                          height: "14px",
                          flexShrink: 0,
                        }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 20 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.5 14C3.2525 14 2.19067 13.5662 1.3145 12.6985C0.438167 11.831 0 10.7706 0 9.51725C0 8.33275 0.407667 7.30583 1.223 6.4365C2.0385 5.56733 2.99625 5.1 4.09625 5.0345C4.32058 3.57817 4.99042 2.375 6.10575 1.425C7.22108 0.475 8.51917 0 10 0C11.6715 0 13.0893 0.582166 14.2535 1.7465C15.4178 2.91067 16 4.3285 16 6V7H16.6155C17.5732 7.03083 18.3767 7.38242 19.026 8.05475C19.6753 8.72725 20 9.54233 20 10.5C20 11.4808 19.6683 12.3093 19.0048 12.9855C18.3413 13.6618 17.5192 14 16.5385 14H11.1155C10.6552 14 10.2708 13.8458 9.9625 13.5375C9.65417 13.2292 9.5 12.8448 9.5 12.3845V6.58075L7.4 8.66925L6.69225 7.98075L10 4.673L13.3077 7.98075L12.6 8.66925L10.5 6.58075V12.3845C10.5 12.5385 10.5641 12.6796 10.6923 12.8077C10.8204 12.9359 10.9615 13 11.1155 13H16.5C17.2 13 17.7917 12.7583 18.275 12.275C18.7583 11.7917 19 11.2 19 10.5C19 9.8 18.7583 9.20833 18.275 8.725C17.7917 8.24167 17.2 8 16.5 8H15V6C15 4.61667 14.5125 3.4375 13.5375 2.4625C12.5625 1.4875 11.3833 1 10 1C8.61667 1 7.4375 1.4875 6.4625 2.4625C5.4875 3.4375 5 4.61667 5 6H4.4615C3.53333 6 2.72433 6.34167 2.0345 7.025C1.34483 7.70833 1 8.53333 1 9.5C1 10.4667 1.34167 11.2917 2.025 11.975C2.70833 12.6583 3.53333 13 4.5 13H7V14H4.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </Link>
                    <Link
                      to="/applicationSetup"
                      className="dropdown-item"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        width: "100%",
                        paddingRight: "6px",
                        boxSizing: "border-box",
                      }}
                    >
                      <span style={{ marginTop: "-5px" }}>
                        Application Setup
                      </span>
                      <span
                        style={{
                          marginLeft: "auto",
                          marginRight: "0",
                          width: "14px",
                          height: "14px",
                          flexShrink: 0,
                        }}
                      >
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 20 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M4.5 14C3.2525 14 2.19067 13.5662 1.3145 12.6985C0.438167 11.831 0 10.7706 0 9.51725C0 8.33275 0.407667 7.30583 1.223 6.4365C2.0385 5.56733 2.99625 5.1 4.09625 5.0345C4.32058 3.57817 4.99042 2.375 6.10575 1.425C7.22108 0.475 8.51917 0 10 0C11.6715 0 13.0893 0.582166 14.2535 1.7465C15.4178 2.91067 16 4.3285 16 6V7H16.6155C17.5732 7.03083 18.3767 7.38242 19.026 8.05475C19.6753 8.72725 20 9.54233 20 10.5C20 11.4808 19.6683 12.3093 19.0048 12.9855C18.3413 13.6618 17.5192 14 16.5385 14H11.1155C10.6552 14 10.2708 13.8458 9.9625 13.5375C9.65417 13.2292 9.5 12.8448 9.5 12.3845V6.58075L7.4 8.66925L6.69225 7.98075L10 4.673L13.3077 7.98075L12.6 8.66925L10.5 6.58075V12.3845C10.5 12.5385 10.5641 12.6796 10.6923 12.8077C10.8204 12.9359 10.9615 13 11.1155 13H16.5C17.2 13 17.7917 12.7583 18.275 12.275C18.7583 11.7917 19 11.2 19 10.5C19 9.8 18.7583 9.20833 18.275 8.725C17.7917 8.24167 17.2 8 16.5 8H15V6C15 4.61667 14.5125 3.4375 13.5375 2.4625C12.5625 1.4875 11.3833 1 10 1C8.61667 1 7.4375 1.4875 6.4625 2.4625C5.4875 3.4375 5 4.61667 5 6H4.4615C3.53333 6 2.72433 6.34167 2.0345 7.025C1.34483 7.70833 1 8.53333 1 9.5C1 10.4667 1.34167 11.2917 2.025 11.975C2.70833 12.6583 3.53333 13 4.5 13H7V14H4.5Z"
                            fill="black"
                          />
                        </svg>
                      </span>
                    </Link>
                  </div>
                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      paddingRight: "6px",
                      boxSizing: "border-box",
                    }}
                    onClick={async () => {
                      localStorage.removeItem("userAttentionPopupShown");
                      try {
                        await dispatch(logoutUser());
                      } catch (error) {
                        // Even if logout API fails, we still want to clear local data and redirect
                        console.error("Logout error:", error);
                      } finally {
                        // Ensure we redirect to login after logout
                        navigate("/login", { replace: true });
                      }
                    }}
                  >
                    Logout
                    <span
                      style={{
                        marginLeft: "auto",
                        marginRight: "0",
                        width: "13px",
                        height: "13px",
                        flexShrink: 0,
                      }}
                    >
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.70141 16C1.22596 16 0.823529 15.8353 0.494118 15.5059C0.164706 15.1765 0 14.774 0 14.2986V1.70141C0 1.22596 0.164706 0.823529 0.494118 0.494118C0.823529 0.164706 1.22596 0 1.70141 0H8.00894V1.41176H1.70141C1.62894 1.41176 1.56259 1.44196 1.50235 1.50235C1.44196 1.56259 1.41176 1.62894 1.41176 1.70141V14.2986C1.41176 14.3711 1.44196 14.4374 1.50235 14.4976C1.56259 14.558 1.62894 14.5882 1.70141 14.5882H8.00894V16H1.70141ZM11.9819 12.0181L11.0045 10.9972L13.296 8.70588H5.26706V7.29412H13.296L11.0045 5.00282L11.9819 3.98188L16 8L11.9819 12.0181Z"
                          fill="#DC3545"
                        />
                      </svg>
                    </span>
                  </button>
                </>
              ) : (
                // Non-Admin view: show same options but visually disabled except logout
                <>
                  <div className="dropdown-section">
                    <ActionItem />
                  </div>
                  <div className="dropdown-divider"></div>

                  <button
                    className="dropdown-item"
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      width: "100%",
                      paddingRight: "6px",
                      boxSizing: "border-box",
                    }}
                    onClick={() => {
                      dispatch(logout());
                      // Clear any stored redirect path since user is intentionally logging out
                      sessionStorage.removeItem("redirectAfterLogin");
                      localStorage.removeItem("userAttentionPopupShown");
                      navigate("/login", { replace: true });
                    }}
                  >
                    Logout
                    <span
                      style={{
                        marginLeft: "auto",
                        marginRight: "0",
                        width: "13px",
                        height: "13px",
                        flexShrink: 0,
                      }}
                    >
                      <svg
                        width="13"
                        height="13"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M1.70141 16C1.22596 16 0.823529 15.8353 0.494118 15.5059C0.164706 15.1765 0 14.774 0 14.2986V1.70141C0 1.22596 0.164706 0.823529 0.494118 0.494118C0.823529 0.164706 1.22596 0 1.70141 0H8.00894V1.41176H1.70141C1.62894 1.41176 1.56259 1.44196 1.50235 1.50235C1.44196 1.56259 1.41176 1.62894 1.41176 1.70141V14.2986C1.41176 14.3711 1.44196 14.4374 1.50235 14.4976C1.56259 14.558 1.62894 14.5882 1.70141 14.5882H8.00894V16H1.70141ZM11.9819 12.0181L11.0045 10.9972L13.296 8.70588H5.26706V7.29412H13.296L11.0045 5.00282L11.9819 3.98188L16 8L11.9819 12.0181Z"
                          fill="#DC3545"
                        />
                      </svg>
                    </span>
                  </button>
                </>
              )}
            </>
          )
          ) : (
            <button
              className="dropdown-item"
              onClick={() => navigate("/login")}
            >
              Login
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export default ProfileDropdown;
